import { isMobileBreakpoint } from '../utils.js';

export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  const $widget = $(`#${widgetName}`);

  $widget.append('<div class="multiFeatureContent"></div>');

  $widget.MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    lazyLoadImages: true,
    maxItemsVisible: 5,
    isResponsive: false,
    allEventsLink: true,
    allEventsLinkText: 'More Upcoming Events',
    link: isMobileBreakpoint ? ['all'] : [''],
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      if (!data.length) {
        $widget.remove();
        $('body').addClass('noEvents');
        return;
      }
      createCustomEventFeed(data);
      updateAllEventsButton(data.length);
    },
  }); // ****************************************************************
  // Helpers

  function createCustomEventFeed(data) {
    $widget.find('.featureItem').each(function (i) {
      const event = data[i];
      const widgetImage = event.ImageURL || `${FULLCLIENTTHEMEPATH}images/no_image_available.jpg`;
      const dateLayout = generateDateLayout(event.Date);

      $(this)
        .empty()
        .append(buildEventInfoLayout(event.Name, widgetImage, event.URL));

      if (event.URL) {
        $(this).find('.button').attr('href', event.URL);
      } else {
        isMobileBreakpoint
          ? $(this).removeAttr('href')
          : $(this).find('.button').removeAttr('href');
        $(this).addClass('void');
      }

      $(this).append(dateLayout);
    });
  }

  function buildEventInfoLayout(title, image, eventUrl) {
    return `
     <div class="img-container">
       ${eventUrl ? `<div class="overlay"><a href="${eventUrl}" class="button white-button">More</a></div>` : ''}
       <img src="${image}" alt="${title}" class="event-image">
       
     </div>
     <div class="event-info">
       <span class="event-name">${title}</span>
     </div>`;
  }

  function generateDateLayout(dateString) {
    const fixedDate = dateString.split('-');
    let [monthStart, dayStart, monthEnd, dayEnd] = ['', '', null, null];

    if (fixedDate.length === 1) {
      monthStart = formatDate(fixedDate[0], 0, 0).substring(0, 3);
      dayStart = formatDate(fixedDate[0], 0, 1);
    } else if (fixedDate.length === 2) {
      monthStart = formatDate(fixedDate[0], 0, 0).substring(0, 3);
      dayStart = formatDate(fixedDate[0], 0, 1);
      monthEnd = formatDate(fixedDate[1], 0, 0).substring(0, 3);
      dayEnd = formatDate(fixedDate[1], 0, 1);
    }

    return buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
  }

  function formatDate(date, partIndex, subPartIndex) {
    return date.trim().split(',')[partIndex].trim().split(' ')[subPartIndex].trim();
  }

  function buildEventDateLayout(
    eventStartMonth,
    eventStartDay,
    eventEndMonth = null,
    eventEndDay = null,
  ) {
    if (!eventEndMonth || !eventEndDay) {
      return `
       <div class="event-date">
         <span class="month">${eventStartMonth}</span>
         <span class="day">${eventStartDay}</span>
       </div>`;
    }
    return `
       <div class="event-date date-range">
         <div class="combo-date">
           <span class="month">${eventStartMonth}</span>
           <span class="day">${eventStartDay}</span>
         </div>
         <span class="separator-month">-</span>
         <div class="combo-date">
           <span class="month">${eventEndMonth}</span>
           <span class="day">${eventEndDay}</span>
         </div>
       </div>`;
  }

  function updateAllEventsButton(eventsQuantity) {
    const $button = $('.all-events-btn');
    $button
      .addClass('button')
      .appendTo('#multiScheduleFeature')
      .wrap('<div class="btn-container"></div>');

    if (eventsQuantity < 2) {
      $button.addClass('singleEvent');
      $('.btn-container, #multiScheduleFeature').addClass('singleEvent');
    }
  }
}
